import { Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lms-button-select',
  templateUrl: './button-select.component.html',
  styleUrls: ['./button-select.component.scss']
})
export class ButtonSelectComponent implements OnInit {
  @Input() public isDisabled?: boolean;
  @Input() public id?: unknown;
  @Input() public title: string;
  @Input() public text: string;
  @Input() public tooltip?: string;
  @Input() public tooltipLeft?: boolean;
  public toggleDropdown: boolean = false;

  constructor(public elementRef: ElementRef) {}

  public ngOnInit() {}

  @HostListener('document:click', ['$event'])
  public hideToggle(event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.toggleDropdown = false;
    }
  }
}
